import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const AccessibilityWidget = () => {
  useEffect(() => {
    // Configure EqualWeb settings
    window.interdeal = {
      sitekey: "7f61da5c76451bda3b5666c0a729b462",
      Position: "left",
      domains: {
        js: "https://cdn.equalweb.com/",
        acc: "https://access.equalweb.com/" 
      },
      Menulang: "EN",
      btnStyle: {
        vPosition: ["50%", "80%"],
        scale: ["0.6", "0.5"],
        color: {
          main: "#c75130",
          second: "#ffffff"
        },
        icon: {
          outline: false,
          type: 2,
          shape: "rectangle"
        }
      }
    };

    // Create and append the script element
    const script = document.createElement('script');
    script.src = `${window.interdeal.domains.js}core/5.1.2/accessibility.js`;
    script.defer = true;
    script.integrity = 'sha512-PUyQFF3HFjRiVfjOiFFu+RTc0nGmLV5FN3CVw8zWFK6pVbWPAEKy9X2bTUn10GNu1EbxN56MuWu0P8ZHC6xv3Q==';
    script.crossOrigin = 'anonymous';
    script.setAttribute('data-cfasync', 'true');

    document.body.appendChild(script);

    // Cleanup function to remove the script when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []); // Empty dependency array means this runs once on mount

  return null; // This component doesn't render anything visible
};

const AccessibilityHead = () => {
  return (
    <Helmet>
      <script type="text/javascript">
        {`
          window.interdeal = {
            "sitekey": "7f61da5c76451bda3b5666c0a729b462",
            "Position": "left",
            "domains": {
              "js": "https://cdn.equalweb.com/",
              "acc": "https://access.equalweb.com/"
            },
            "Menulang": "EN",
            "btnStyle": {
              "vPosition": ["50%", "80%"],
              "scale": ["0.6", "0.5"],
              "color": {
                "main": "#c75130",
                "second": "#ffffff"
              },
              "icon": {
                "outline": false,
                "type": 2,
                "shape": "rectangle"
              }
            }
          };
          (function(doc, head, body){
            var coreCall = doc.createElement('script');
            coreCall.src = interdeal.domains.js + 'core/5.1.2/accessibility.js';
            coreCall.defer = true;
            coreCall.integrity = 'sha512-PUyQFF3HFjRiVfjOiFFu+RTc0nGmLV5FN3CVw8zWFK6pVbWPAEKy9X2bTUn10GNu1EbxN56MuWu0P8ZHC6xv3Q==';
            coreCall.crossOrigin = 'anonymous';
            coreCall.setAttribute('data-cfasync', true);
            body? body.appendChild(coreCall) : head.appendChild(coreCall);
          })(document, document.head, document.body);
        `}
      </script>
    </Helmet>
  );
};

export default AccessibilityWidget;
export { AccessibilityHead }; 